export enum EPaymentMethod {
  Advance = 'advance',
  FullPayment = 'full_payment',
  DirectPayment = 'direct_payment',
  UnKnow = ''
}
